import React, { FC } from "react";

import { useBoolean } from "~/hooks";

import { AreaChartModal } from "./AreaChartModal";

import { ButtonWithIcon, AreaChart } from "~/ui";
import { Loading } from "~/ui";

type PropsType = {
  isLoading: boolean;
  title: string;
  unitName?: string;
  datasets?: {
    name: string;
    value: number;
  }[];
  className?: string;
  graphClassName?: string;
  onlyModalTitle?: boolean;
};

export const AreaChartBox: FC<PropsType> = ({
  isLoading,
  title,
  datasets,
  className = "",
  graphClassName = "",
  onlyModalTitle = false,
}: PropsType) => {
  const { isChecked: open, setTrue, setFalse } = useBoolean(false);

  return (
    <div className={`max-w-full ${className}`}>
      {!onlyModalTitle && (
        <p className="font-semibold text-prim ary-600 text-lg text-center">
          {title}
        </p>
      )}
      <div
        className={`shadow mt-4 p-4 rounded-md flex justify-center text-center px-8 ${graphClassName}`}
      >
        {isLoading ? (
          <Loading />
        ) : (
          datasets && (
            <>
              <AreaChart datasets={datasets} />
              <ButtonWithIcon
                srOnlyText="グラフを拡大する"
                icon={{
                  icon: "ioScanOutline",
                  color: "text-secondary-600",
                  size: "1.25rem",
                }}
                onClick={setTrue}
                className="flex justify-end"
              />
            </>
          )
        )}
      </div>
      {datasets && open && (
        <AreaChartModal
          onClose={setFalse}
          title={title}
          datasets={datasets}
          className="mt-4"
        />
      )}
    </div>
  );
};
